import React from 'react'
import "./Navbar.css";
import logo from "../../assets/logo-512.png";
import arrow from "../../assets/cross-arrow.svg";

export default function Navbar() {
    return (
        <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container">
                <div className="navbar-section">
                    {/* Logo ve başlık */}
                    <a href="/" className="navbar-brand d-flex align-items-center">
                        <img
                            src={logo}
                            alt="Commito Logo"
                            className="logo"
                        />
                        <div className="ms-2 d-flex align-items-center">
                            <strong className='navbar-brand-name'>Commito</strong>
                            <div className="divider"></div>
                            <span className="navbar-brand-slogan">Commit to a <br /> better you.</span>
                        </div>
                    </a>

                    {/* Menü bağlantıları */}
                    <div className="d-flex align-items-center">
                        <a href="#hero" className="btn btn1 btn-outline-dark rounded-pill me-3">
                            Home
                        </a>
                        <a href="#features" className="btn btn2 rounded-pill me-3">
                            About
                        </a>
                        <a href="https://apps.apple.com/us/app/commito/id6642675101" target='_blank' rel="noreferrer" className="btn btn-outline-dark rounded-pill d-flex">
                            <p><span>Free </span>Download</p><img className='navbar-arrow' src={arrow} alt="" />
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    )
}
